import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import BookingModal from './BookingModal';

export default function Hero() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  return (
    <div className="relative bg-gradient-to-br from-ayurveda-green-light via-white to-ayurveda-gold-light overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-72 h-72 bg-ayurveda-green rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-ayurveda-gold rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-ayurveda-green-dark leading-tight">
                Natural Ayurvedic Healing for Body & Mind
              </h1>
              <div className="mt-4 h-1 w-24 bg-ayurveda-gold rounded"></div>
            </div>
            
            <p className="text-lg sm:text-xl text-gray-700 leading-relaxed">
              Ancient wisdom, modern care – balance your body and spirit with our expert 
              Ayurveda therapies. Experience holistic wellness through time-tested natural treatments.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={() => setIsBookingModalOpen(true)}
                className="btn-primary text-center"
              >
                Book Appointment
              </button>
              <Link to="/services" className="btn-outline text-center">
                Our Services
              </Link>
            </div>

            {/* Quick Info */}
            <div className="flex flex-wrap gap-6 pt-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-ayurveda-green-light rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-ayurveda-green-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <p className="font-semibold text-ayurveda-green-dark">100% Natural</p>
                  <p className="text-sm text-gray-600">Herbal Treatments</p>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-ayurveda-gold-light rounded-full flex items-center justify-center">
                  <svg className="w-6 h-6 text-ayurveda-gold" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <div>
                  <p className="font-semibold text-ayurveda-green-dark">Expert Care</p>
                  <p className="text-sm text-gray-600">Experienced Practitioners</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="hidden lg:block">
            <div className="relative">
              <div className="absolute inset-0 bg-ayurveda-green opacity-10 rounded-3xl transform rotate-6"></div>
              <img 
                src="/hero-image.jpg" 
                alt="Ayurvedic Treatment" 
                className="relative rounded-3xl shadow-2xl object-cover w-full h-[500px]"
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 600"><rect fill="%23E8F5E9" width="800" height="600"/><text x="50%" y="50%" font-size="32" text-anchor="middle" fill="%234CAF50" font-family="sans-serif">Ayurvedic Healing</text></svg>';
                }}
              />
              {/* Floating card */}
              <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-6 max-w-xs">
                <p className="text-3xl font-bold text-ayurveda-green-dark">15+ Years</p>
                <p className="text-gray-600 mt-1">of Trusted Ayurvedic Care</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Booking Modal */}
      <BookingModal 
        isOpen={isBookingModalOpen} 
        onClose={() => setIsBookingModalOpen(false)} 
      />
    </div>
  );
}
